import { Text } from '@wartek-id/text'

import { LoadingState } from 'app/ProfileRevampPage/components/LoadingState'
import Notification from 'app/ProfileRevampPage/components/Notification'
import { usePersonalData } from 'app/ProfileRevampPage/hooks/usePersonalData'
import { PERSONAL_DATA_KEYS } from 'app/ProfileRevampPage/constants'

const SectionPersonalData = () => {
  const { personalData, personalDataFetchStatus } = usePersonalData()

  return (
    <>
      {personalDataFetchStatus === 'loading' && (
        <div className="p-4">
          <LoadingState data-testid="profile-personal-data-loading" />
        </div>
      )}

      {personalDataFetchStatus === 'success' && (
        <>
          <Notification
            data-testid="profile-notification-personal-data"
            className="!bg-surface-selected-default"
          >
            Data ini tidak ditampilkan dan hanya terlihat oleh Anda.
          </Notification>

          <div
            data-testid="profile-personal-data"
            className="p-4 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-4 lg:p-6"
          >
            {Object.keys(PERSONAL_DATA_KEYS).map((key) => (
              <div key={`personal-data-item-${key}`} className="mb-4">
                <Text variant="helper" color="disabled" className="mb-[2px]">
                  {PERSONAL_DATA_KEYS[key]}
                </Text>
                <Text className="break-words">
                  {Boolean(personalData?.[key]) ? personalData[key] : '-'}
                </Text>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default SectionPersonalData
